import SignUpModal from "../component/auth/signUpModal";

export const Register = () => {
    return (
        <div>
            <SignUpModal />
        </div>
    );
}